"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbsStructuredData = void 0;
var StructuredData_1 = require("./StructuredData");
var BreadcrumbsStructuredData = /** @class */ (function () {
    function BreadcrumbsStructuredData(breadcrumbLists) {
        this.breadcrumbLists = breadcrumbLists;
    }
    BreadcrumbsStructuredData.prototype.generate = function () {
        var _this = this;
        this.breadcrumbLists.forEach(function (list) {
            var itemListElement = [];
            var items = list.querySelectorAll('li.breadcrumb-item');
            items.forEach(function (item, index) {
                var _a, _b, _c;
                var anchor = item.querySelector('a.breadcrumb');
                var label = (_c = (_b = (_a = item.querySelector('.breadcrumb')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : '';
                var href = (anchor === null || anchor === void 0 ? void 0 : anchor.getAttribute('href')) || document.location.href;
                var absoluteHref = _this.resolveUrl(href);
                if (label) {
                    itemListElement.push({
                        '@type': 'ListItem',
                        'position': index + 1,
                        'item': {
                            '@id': absoluteHref,
                            'name': label,
                        },
                    });
                }
            });
            if (itemListElement.length > 0) {
                StructuredData_1.StructuredDataUtils.insertToDOM({
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: itemListElement,
                });
            }
        });
    };
    BreadcrumbsStructuredData.prototype.resolveUrl = function (href) {
        try {
            return new URL(href, document.location.href).href;
        }
        catch (_a) {
            return document.location.href;
        }
    };
    return BreadcrumbsStructuredData;
}());
exports.BreadcrumbsStructuredData = BreadcrumbsStructuredData;
